import { useCallback, useState } from 'react';

export type UseSentWelcomeEmailsReturn = {
  isSent: (dinerId: string) => boolean;
  markAsSent: (dinerId: string) => void;
};

export const useSentWelcomeEmails = (): UseSentWelcomeEmailsReturn => {
  const [sentDinerIds, setSentDinerIds] = useState<Record<string, boolean>>({});

  const markAsSent = useCallback((dinerId: string): void => {
    setSentDinerIds((previouslySent) => ({
      ...previouslySent,
      [dinerId]: true,
    }));
  }, []);

  const isSent = useCallback(
    (dinerId: string): boolean => Boolean(sentDinerIds[dinerId]),
    [sentDinerIds]
  );

  return { isSent, markAsSent };
};
